module.exports = __webpack_public_path__ + "public/img/benyuekaijilvtubiao.0c1d40a3.png";